import React from "react";
import PVMain from "./Main";
import { PVContextProvider } from "./PV.Context";

export default function PVModeling() {
  return (
    <PVContextProvider>
      <PVMain />
    </PVContextProvider>
  );
}
